import React, { PureComponent } from 'react';
import cn from 'classnames';
import { connect } from 'react-redux';
import history from 'pages/router/history';
import qs from 'qs';
import styled from '@emotion/styled';

import { Button } from '@lightspeed/flame/Button';
import { IconChevronUpDown } from '@lightspeed/flame/Icon/ChevronUpDown';
import { IconChevronUp } from '@lightspeed/flame/Icon/ChevronUp';
import { IconChevronDown } from '@lightspeed/flame/Icon/ChevronDown';
import { color, spacing, fontSize } from '@lightspeed/cirrus-tokens/utils';

import sortAction from 'pages/store/actions/sort';
import { getSort } from 'pages/store/selectors';

const SortingButton = styled(Button)`
  font-size: ${fontSize('s')};
  padding: ${spacing(1)};
  border: none;
  box-shadow: none !important;
  background-color: ${color('snow')};
  background-image: none;
  text-align: left;
  min-height: ${spacing(5)};
  height: auto;

  &:active,
  &:hover,
  &:focus {
    outline: none;
    box-shadow: none;
    background-color: ${color('snow')};
  }
`;
class TableSorter extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleSorterClick = this.handleSorterClick.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentDidMount() {
    this.updateTableSorter();
  }

  componentDidUpdate(prevProps) {
    if (this.props.sortKey === this.props.sort.sortKey) {
      if (
        prevProps.sort.sortKey !== this.props.sort.sortKey ||
        prevProps.sort.sortOrder !== this.props.sort.sortOrder
      ) {
        this.updateTableSorter({ pushHistory: true });
      }
    }
  }

  updateTableSorter({ pushHistory } = {}) {
    let search = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    const { sort, ...searchWithoutSort } = search;
    const { sortOrder, sortKey } = this.props.sort;
    const prefix = sortOrder === 'desc' ? '-' : '';

    if (sortOrder) {
      searchWithoutSort.sort = prefix + sortKey;
    }

    search = qs.stringify(searchWithoutSort, {
      encode: true,
    });

    if (pushHistory || sortKey === this.props.sortKey) {
      history.replace({ pathname: window.location.pathname, search });
    } else if (sort && this.props.sortKey === sort.replace(/^-/, '')) {
      // Page is refreshed
      // @TODO Prevent pushing to history
      this.props.sortData({
        sortKey: this.props.sortKey,
        sortOrder: /^-/.test(sort) ? 'desc' : 'asc',
        entity: this.props.entity,
      });
    }
  }

  handleSorterClick() {
    let sortOrder = 'asc';
    if (this.props.sort.sortOrder && this.props.sortKey === this.props.sort.sortKey) {
      sortOrder = this.props.sort.sortOrder === 'asc' ? 'desc' : undefined;
    }

    this.props.sortData({ sortKey: this.props.sortKey, sortOrder, entity: this.props.entity });

    if (!this.state.forceDisabled) {
      this.setState({
        forceDisabled: true,
      });
    }
  }

  handleMouseLeave() {
    this.setState({
      forceDisabled: false,
    });
  }

  render() {
    const icons = {
      chevronUpDown: <IconChevronUpDown />,
      chevronUp: <IconChevronUp />,
      chevronDown: <IconChevronDown />,
    };
    const { forceDisabled } = this.state;
    const { sortKey, sort, children } = this.props;
    const isSorter = sort.sortKey === sortKey;
    let icon = icons.chevronUpDown;
    const classNames = cn('retail-table-sorter', {
      active: isSorter && sort.sortOrder,
      disabled: isSorter && forceDisabled && !sort.sortOrder,
      [`sort--${sort.sortOrder}`]: isSorter && sort.sortOrder,
    });

    if (isSorter && !!sort.sortOrder) {
      icon = sort.sortOrder === 'asc' || !sort.sortOrder ? icons.chevronUp : icons.chevronDown;
    }

    return (
      <div className={classNames}>
        <SortingButton
          data-test="table-sort-button"
          onClick={this.handleSorterClick}
          onMouseLeave={this.handleMouseLeave}
        >
          {children}
          {icon}
        </SortingButton>
      </div>
    );
  }
}

TableSorter.defaultProps = {
  sort: {
    sortKey: null,
    sortOrder: null,
  },
};

const mapStateToProps = (state, props) => ({
  sort: getSort(props.entity)(state),
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  sortData: ({ sortKey, sortOrder, entity }) =>
    dispatch(sortAction({ sortKey, sortOrder, entity })),
});

export default connect(mapStateToProps, mapDispatchToProps)(TableSorter);
